import Component from "@ember/component"
import { action, get, set } from "@ember/object"
import { inject as service } from "@ember/service"
import { handleError } from "cc-frontend/error-handling"
import type GooglePickerAuth from "cc-frontend/services/google-picker-auth"
import _ from "lodash"
import { Promise } from "rsvp"
import ENV from "../../config/environment"
import styles from "./attach-files-dropdown.module.css"

export default class AttachFilesDropdown extends Component {
  readonly styles = styles
  onAttachFiles!: Function
  onAttachLink!: Function
  openedAttachDialog!: Function
  cardId!: Function

  dropPanePicker: any = null

  @service filestack
  @service dialog
  @service declare googlePickerAuth: GooglePickerAuth

  uploadHasStarted = false

  _addFromGoogle() {
    var developerKey = ENV.GOOGLE_API_CONSOLE_KEY

    return new Promise((resolve) => {
      this.googlePickerAuth
        .requestAccessToken()
        .then((accessToken) => {
          createPicker(accessToken)
        })
        .catch((error) => {
          console.error("Auth result from Google", error)
          if (window && window.swal) {
            window
              .swal({
                title: "Authentication wasn't successful.",
                text: `Error: ${JSON.stringify(error)}`,
                type: "error",
                showCancelButton: false,
              })
              .catch((error) => {
                if (error instanceof Error) handleError(error)
              })
          }
        })

      // Create and render a Picker object for searching images.
      function createPicker(oauthToken) {
        // @ts-ignore
        let myFilesView = new google.picker.DocsView(google.picker.ViewId.DOCS)
          .setOwnedByMe(true)
          .setLabel("My Files")
          .setSelectFolderEnabled(true)
          // @ts-ignore
          .setMode(google.picker.DocsViewMode.LIST)
        // @ts-ignore
        let myStarredFilesView = new google.picker.DocsView(google.picker.ViewId.DOCS)
          .setOwnedByMe(true)
          .setLabel("My Starred Files")
          .setStarred(true)
          .setSelectFolderEnabled(true)
          // @ts-ignore
          .setMode(google.picker.DocsViewMode.LIST)

        // @ts-ignore
        let teamDriveView = new google.picker.DocsView(google.picker.ViewId.DOCS)
          .setEnableDrives(true)
          .setIncludeFolders(true)
          .setLabel("Shared Files")
          .setSelectFolderEnabled(true)

        // @ts-ignore
        let folderView = new google.picker.DocsView(google.picker.ViewId.DOCS)
          .setIncludeFolders(true)
          .setSelectFolderEnabled(true)
          .setLabel("Folders")
          // @ts-ignore
          .setMode(google.picker.DocsViewMode.LIST)

        // @ts-ignore
        var picker = new google.picker.PickerBuilder()
          // @ts-ignore
          .enableFeature(google.picker.Feature.MULTISELECT_ENABLED)
          // @ts-ignore
          .enableFeature(google.picker.Feature.SUPPORT_TEAM_DRIVES)
          .addView(myFilesView)
          .addView(myStarredFilesView)
          .addView(teamDriveView)
          .addView(folderView)
          // @ts-ignore
          .addView(new google.picker.DocsUploadView())
          // @ts-ignore
          .addView(google.picker.ViewId.RECENTLY_PICKED)
          .setAppId(171418864917)
          .setDeveloperKey(developerKey)
          .setOAuthToken(oauthToken)
          .setCallback(pickerCallback)
          .build()

        picker.setVisible(true)
      }

      // A simple callback implementation.
      function pickerCallback(data) {
        if (data.docs === undefined) return []
        let files = _.map(data.docs, function (doc) {
          if (doc.type !== "image") doc.type = "file"

          return {
            title: doc.name,
            url: doc.url,
            icon: doc.iconUrl,
            type: doc.type,
          }
        })
        return resolve(files)
      }
    })
  }

  _addFromDropbox() {
    return new Promise((resolve) => {
      // @ts-ignore
      Dropbox.choose({
        linkType: "preview",
        multiselect: true,
        success(dropboxFiles) {
          let files = _.map(dropboxFiles, function (file) {
            var url = file.link.replace("www.dropbox", "dl.dropboxusercontent") + "?dl=1"
            var type = _.keys(file.thumbnails).length > 0 ? "image" : "file"

            return {
              title: file.name,
              url: url,
              icon: file.icon,
              type: type,
            }
          })
          resolve(files)
        },
      })
    })
  }

  _addFromOneDrive() {
    return new Promise((resolve) => {
      this.filestack.client
        .picker({
          fromSources: ["onedrive", "onedriveforbusiness"],
          maxFiles: 20,
          onUploadDone: (res) => {
            let files = this.filestack.asAttachments(res.filesUploaded)
            this.onAttachFiles("onedrive", files)
            resolve(files)
          },
        })
        .open()
    })
  }

  _addFromOneOther() {
    return new Promise((resolve) => {
      this.filestack.client
        .picker({
          fromSources: [
            "imagesearch",
            "webcam",
            "video",
            "audio",
            "instagram",
            "gmail",
            "facebook",
            "unsplash",
          ],
          maxFiles: 20,
          onUploadDone: (res) => {
            let files = this.filestack.asAttachments(res.filesUploaded)
            this.onAttachFiles("other", files)
            resolve(files)
          },
        })
        .open()
    })
  }

  didInsertElement() {
    // @ts-ignore
    super.didInsertElement(...arguments)
    let picker = this.filestack.client.picker({
      container: "#upload-dropzone-" + get(this, "cardId"),
      displayMode: "dropPane",
      dropPane: {
        showIcon: false,
        customText: " ",
      },
      onUploadDone: (res) => {
        console.log("res", res)
        let files = this.filestack.asAttachments(res.filesUploaded)
        this.onAttachFiles("drag", files)

        if (this.isDestroyed || this.isDestroying) return
        set(this, "uploadHasStarted", false)
      },
      onFileUploadStarted: (_files) => {
        if (this.isDestroyed || this.isDestroying) return
        set(this, "uploadHasStarted", true)
      },
      maxFiles: 20,
      onFileSelected(file) {
        // Handle case where it intercepts the paste option and
        // uploads the file.
        if (file.filename === "image.png") {
          throw new Error()
        } else {
          return file
        }
      },
    })

    set(this, "dropPanePicker", picker)
    picker.open()
  }

  willDestroyElement() {
    // @ts-ignore
    super.willDestroyElement(...arguments)
    if (this.uploadHasStarted !== true) this.dropPanePicker.close()
  }

  @action
  addFromDropbox() {
    // @ts-ignore
    if (typeof window.Dropbox === "undefined") {
      window
        .swal({
          title: `Dropbox didn't load their file picker correctly.`,
          text: `Try refreshing the page. If this keeps happening, it's possible your network is blocking it. Contact support@commonplanner.com for help!`,
          type: "warning",
        })
        .catch((error) => {
          if (error instanceof Error) handleError(error)
        })
      return null
    }
    this.openedAttachDialog()
    this._addFromDropbox().then((files) => {
      this.onAttachFiles("dropbox", files)
    })
    return true
  }

  @action
  addFromGoogle(): null | void {
    // @ts-ignore
    if (typeof window.gapi === "undefined") {
      window
        .swal({
          title: `Google didn't load their file picker correctly.`,
          text: `Try refreshing the page. If this keeps happening, it's possible your network is blocking it. Contact support@commonplanner.com for help!`,
          type: "warning",
        })
        .catch((error) => {
          if (error instanceof Error) handleError(error)
        })
      return null
    }
    this.openedAttachDialog()
    this._addFromGoogle().then((files) => {
      this.onAttachFiles("google", files)
    })
  }

  @action
  addFromOneDrive() {
    this.openedAttachDialog()
    this._addFromOneDrive()
  }

  @action
  addFromOther() {
    this.openedAttachDialog()
    this._addFromOneOther()
    // .then(files => {
    //   this.sendAction("onAttachFiles", "other", files)
    // })
  }

  @action
  addLink() {
    this.onAttachLink()
  }
}
